import React from "react";

import { Button } from "antd";
import cx from "classnames";

import { Tooltip } from "DesignSystem/Tooltip";
import { CloseIcon } from "components/Icons";
import { ReactComponent as DownArrowIcon } from "resources/icons/down-arrow-icon-accent.svg";

import "./Button.scss";

export const PrimaryButton = (props) => {
  return (
    <Button {...props} className={`primaryButton ${props.className}`}>
      {props.children}
    </Button>
  );
};

export const SecondaryButton = (props) => {
  return (
    <Button {...props} className={`secondaryButton ${props.className}`}>
      {props.children}
    </Button>
  );
};

export const SecondaryButtonNewMedium = ({ className, children, ...rest }) => {
  return (
    <div
      {...rest}
      className={cx("cursor-pointer secondary-button-medium", className)}
    >
      {children}
    </div>
  );
};

export const SecondaryButtonNewLarge = ({ className, children, ...rest }) => {
  return (
    <Button
      className={cx("cursor-pointer secondary-button-large", className)}
      {...rest}
    >
      {children}
    </Button>
  );
};

export const TertiaryButton = (props) => {
  return (
    <Button {...props} className={`tertiaryButton ${props.className}`}>
      {props.children}
    </Button>
  );
};

export const DangerButton = (props) => {
  return (
    <Button {...props} className={`dangerButton ${props.className}`}>
      {props.children}
    </Button>
  );
};

export const PrimaryButtonWithTooltip = ({
  isNominateSubmitCard,
  ...props
}) => {
  const buttonClassNames = cx(
    "primaryButton",
    {
      "w-100": isNominateSubmitCard,
      "cursor-not-allowed": props.disabled,
      "cursor-pointer": !props.disabled,
    },
    props.className
  );

  const wrapperClassNames = cx({
    "w-100": isNominateSubmitCard,
  });

  return (
    <Tooltip title={props.title}>
      <div className={wrapperClassNames}>
        <Button
          {...props}
          title=""
          disabled={props.disabled}
          className={buttonClassNames}
          style={props.style}
        >
          {props.children}
        </Button>
      </div>
    </Tooltip>
  );
};

export const ButtonWithTooltip = (props) => {
  return (
    <Tooltip title={props.title}>
      <Button
        {...props}
        style={{
          cursor: props.disabled ? "not-allowed" : "pointer",
          ...props.style,
        }}
        className={`secondaryButton ${props.className}`}
      >
        {props.children}
      </Button>
    </Tooltip>
  );
};

export const SecondaryButtonWithTooltip = ({ isApprovalcards, ...props }) => {
  const buttonClassNames = cx(
    "secondaryButton",
    {
      "w-100": isApprovalcards,
      "cursor-not-allowed": props.disabled,
      "cursor-pointer": !props.disabled,
    },
    props.className
  );

  const wrapperClassNames = cx({
    "w-100": isApprovalcards,
  });

  return (
    <Tooltip title={props.title}>
      <div className={wrapperClassNames}>
        <Button
          {...props}
          title=""
          disabled={props.disabled}
          className={buttonClassNames}
          style={props.style}
        >
          {props.children}
        </Button>
      </div>
    </Tooltip>
  );
};

export const DropdownButton = ({ children, icon, className, ...props }) => {
  return (
    <div {...props} className={cx("add-columns-button", className)}>
      <span className="add-columns-button-content">
        <span className="add-columns-button-text">{children}</span>
      </span>
      <span className="add-columns-button-arrow">
        <span className="add-columns-button-divider" />
        <DownArrowIcon />
      </span>
    </div>
  );
};

export const ModalCloseButton = (props) => {
  return (
    <div
      {...props}
      className={`flex align-center justify-center close-btn-wrapper ${props.className}`}
    >
      <CloseIcon width={12} height={12} />
    </div>
  );
};
